<template>
  <section class="is-card">
    <div>
      <h2 class="is-bolder font-lg">
        Olá
      </h2>
      <p>
        Aqui está o essencial para o seu dia.
      </p>
    </div>
    <template v-if="hasForm">
      <component
        :is="componentForm.component"
      />
    </template>
    <CreditCardCTA
      v-if="userCanAccessCreditCard"
    />
  </section>
</template>

<script>
export default {
  name: 'NotifySection',
  components: {
    CreditCardCTA: () => import('@/components/Alerts/CreditCardCTA.vue'),
  },
  data: () => ({
    formName: '',
  }),
  computed: {
    hasForm() {
      return !!this.formName;
    },
    componentForm() {
      if (!this.hasForm) return null;

      return {
        component: () => import(`@/components/Alerts/${this.formName}.vue`),
      };
    },
    userCanAccessCreditCard() {
      const { routers } = JSON.parse(localStorage.getItem('menu'));
      return routers.some((route) => route['menu-item'] === 'Cartão de Crédito');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/src/_textVariables.scss';

section {
  margin-top: 24px;

  display: grid;
  gap: 1.5rem;
}
</style>
